import { linkWhatsapp, linkInstagram, formatarWhatsapp, limparInstagram } from "../utils/contatoLoja";

const iconeProps = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true };

const IconeChat = () => (
  <svg {...iconeProps}><path d="M21 12a8 8 0 0 1-8 8H4l2.6-3.4A8 8 0 1 1 21 12z" /></svg>
);
const IconeWhatsapp = () => (
  <svg {...iconeProps}>
    <path d="M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 20.5l1.7-5A8.5 8.5 0 1 1 21 11.5z" />
    <path d="M9 8.8c.2 2.6 3.6 6 6.2 6.2l1-1.4-2.1-1-.9.7c-.9-.4-1.9-1.3-2.4-2.3l.7-.9-1-2.1-1.5.8z" />
  </svg>
);
const IconeInstagram = () => (
  <svg {...iconeProps}>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

// Contato da vitrine (Configurações → Loja) + botão de chat com o vendedor.
// "botoes" = linha de ações do topo; "rodape" = links discretos no rodapé.
// Não renderiza nada quando não há contato cadastrado nem chat.
export function ContatoLoja({ contato, nomeLoja, variante = "botoes", onChat, chatNaoLido = false }) {
  const wa = linkWhatsapp(contato?.whatsapp, `Olá! Vim pela loja ${nomeLoja || ""} e queria tirar uma dúvida.`.replace("  ", " "));
  const ig = linkInstagram(contato?.instagram);
  const chat = variante === "botoes" && !!onChat;
  if (!wa && !ig && !chat) return null;

  if (variante === "rodape") {
    return (
      <div className="store-footer-links">
        {wa && <a href={wa} target="_blank" rel="noopener noreferrer"><IconeWhatsapp />WhatsApp {formatarWhatsapp(contato.whatsapp)}</a>}
        {ig && <a href={ig} target="_blank" rel="noopener noreferrer"><IconeInstagram />@{limparInstagram(contato.instagram)}</a>}
      </div>
    );
  }

  return (
    <div className="store-contact">
      {chat && (
        <button type="button" className="is-chat" onClick={onChat}>
          <IconeChat />Falar com a loja
          {chatNaoLido && <span className="store-unread-dot" role="status" aria-label="Nova resposta da loja" />}
        </button>
      )}
      {wa && <a className="is-whatsapp" href={wa} target="_blank" rel="noopener noreferrer" aria-label={`WhatsApp ${formatarWhatsapp(contato.whatsapp)}`}><IconeWhatsapp />WhatsApp</a>}
      {ig && <a className="is-instagram" href={ig} target="_blank" rel="noopener noreferrer" aria-label={`Instagram @${limparInstagram(contato.instagram)}`}><IconeInstagram />Instagram</a>}
    </div>
  );
}
